import { createBrowserRouter } from 'react-router-dom';

import {
    Home, RefundPolicy, TermsofServices, PrivacyPolicy, Disclaimer, ContactUs, ProjectSubmission, AboutUs,
    GigDetails, HelpCenter, Services, SignUpClient, SignInClient, ClientDashboard, Messaging, ClientSettings, ClientProjects, NewGig
    , CategoryShow, TodayGigs, Tutorial, AddPaymentMethod, Notifications, AdminSettings, SignInAdmin, ActivateAdmin,
    PaymentMethodSelector, Checkout, AddNewGig, Hellocians, Clients, Gigs, Projects, NewCategory, AddNewHellocian, HellocianProjects,
    AdminDashboard, HellocianOverview, ResendActivationLink, ActivateAccount, ForgotPassword, ResetPassword,
    Admins, SetupPassword, AdminGigDetail, EditGig, PaymentPage, PaymentSuccess, PaymentCancel, HellocianSettings,
    ProjectRequests,
    HireTalents,
    VideoCall,
    OrderPaymentPage,
    OrderPaymentSuccess,
    HowItWorks
} from './pages/pages';

import { Outlet } from 'react-router-dom';
import ThemeSync from './components/shared/ThemeSync';
import ScrollToTop from './utils/ScrollToTop';
import Protect from './services/auth/Protect';
import RoleBasedProtectedRoute from './services/auth/RoleBasedProtectedRoute';
import PublicOnlyRoute from './services/auth/PublicOnlyRoute';

const RootLayout = () => {
    return (
        <>
            <ThemeSync />
            <ScrollToTop>
                <Outlet />
            </ScrollToTop>
        </>
    );
};

export const AppRouter = createBrowserRouter([
    {
        path: '/',
        element: <RootLayout />,
        children: [
            {
                index: true,
                element: <Home />
            },
            {
                path: 'refund-policy',
                element: <RefundPolicy />
            },
            {
                path: 'terms-of-services',
                element: <TermsofServices />
            },
            {
                path: 'privacy-policy',
                element: <PrivacyPolicy />
            },
            {
                path: 'disclaimer',
                element: <Disclaimer />
            },
            {
                path: 'how-it-works',
                element: <HowItWorks />
            },
            {
                path: 'contact-us',
                element: <ContactUs />
            },
            {
                path: 'project-submission',
                element: <ProjectSubmission />
            },
            {
                path: 'about-us',
                element: <AboutUs />
            },
            {
                path: 'tutorials',
                element: <Tutorial />
            },
            {
                path: 'gigs/:gigSlug',
                element: <GigDetails />
            },
            {
                path: 'help-center',
                element: <HelpCenter />
            },
            {
                path: 'services',
                element: <Services />
            },
            {
                path: 'hire-talents',
                element: <HireTalents />
            },
            {
                path: 'payment/:gigId/:package',
                element: <PaymentPage />
            },
            {
                path: 'payment/success',
                element: <PaymentSuccess />
            },
            {
                path: 'payment/cancel',
                element: <PaymentCancel />
            },
            {
                path: 'payment/order/:orderId/:paymentIndex',
                element: <Protect><OrderPaymentPage /></Protect>
            },
            {
                path: 'payment/order-success',
                element: <OrderPaymentSuccess />
            },
            {
                path: 'call/:roomID',
                element: <Protect><VideoCall /></Protect>
            },
            {
                path: 'clients/signup',
                element: <PublicOnlyRoute><SignUpClient /></PublicOnlyRoute>
            },
            {
                path: 'clients/signin',
                element: <PublicOnlyRoute><SignInClient /></PublicOnlyRoute>
            },
            {
                path: 'admins/signin',
                element: <PublicOnlyRoute><SignInAdmin /></PublicOnlyRoute>
            },
            {
                path: 'resend-activatation-link',
                element: <PublicOnlyRoute><ResendActivationLink /></PublicOnlyRoute>
            },
            {
                path: 'activate/:code',
                element: <PublicOnlyRoute><ActivateAccount /></PublicOnlyRoute>
            },
            {
                path: 'forgot-password',
                element: <PublicOnlyRoute><ForgotPassword /></PublicOnlyRoute>
            },
            {
                path: 'reset-password/:token',
                element: <PublicOnlyRoute><ResetPassword /></PublicOnlyRoute>
            },
            {
                path: 'hellocians/setup-password/:token',
                element: <SetupPassword />
            },
            {
                path: 'clients/projects',
                element: <Protect><ClientProjects /></Protect>
            },
            {
                path: 'clients/dashboard',
                element: <Protect><ClientDashboard /></Protect>
            },
            {
                path: 'clients/messages/:chatId?',
                element: <Protect><Messaging /></Protect>
            },
            {
                path: 'admins/messages/:chatId?',
                element: <RoleBasedProtectedRoute allowedRole={['admin', 'super-admin']} backTo="/admins/signin"><Messaging /></RoleBasedProtectedRoute>
            },
            {
                path: 'clients/settings',
                element: <Protect><ClientSettings /></Protect>
            },
            {
                path: 'admins/settings',
                element: <RoleBasedProtectedRoute allowedRole={['admin', 'super-admin']} backTo="/admins/signin"><AdminSettings /></RoleBasedProtectedRoute>
            },
            {
                path: 'admins/new-gig',
                element: <RoleBasedProtectedRoute allowedRole={['admin', 'super-admin']} backTo="/admins/signin"><NewGig /></RoleBasedProtectedRoute>
            },
            {
                path: 'category/:category',
                element: <CategoryShow />
            },
            {
                path: 'today-gigs',
                element: <TodayGigs />
            },
            {
                path: 'checkout',
                element: <Protect><Checkout /></Protect>
            },
            {
                path: 'clients/add-payment-method',
                element: <Protect><AddPaymentMethod /></Protect>
            },
            {
                path: 'notifications',
                element: <Protect><Notifications /></Protect>
            },
            {
                path: 'clients/select-payment-method',
                element: <Protect><PaymentMethodSelector /></Protect>
            },
            {
                path: 'admins/add-new-gig',
                element: <RoleBasedProtectedRoute allowedRole={['admin', 'super-admin']} backTo="/admins/signin"><AddNewGig /></RoleBasedProtectedRoute>
            },
            {
                path: 'admins/activate',
                element: <ActivateAdmin />
            },
            {
                path: 'admins/hellocians',
                element: <RoleBasedProtectedRoute allowedRole={['admin', 'super-admin']} backTo="/admins/signin"><Hellocians /></RoleBasedProtectedRoute>
            },
            {
                path: 'admins/clients',
                element: <RoleBasedProtectedRoute allowedRole={['admin', 'super-admin']} backTo="/admins/signin"><Clients /></RoleBasedProtectedRoute>
            },
            {
                path: 'admins/manage',
                element: <RoleBasedProtectedRoute allowedRole={['admin', 'super-admin']} backTo="/admins/signin"><Admins /></RoleBasedProtectedRoute>
            },
            {
                path: 'admins/gigs',
                element: <RoleBasedProtectedRoute allowedRole={['admin', 'super-admin']} backTo="/admins/signin"><Gigs /></RoleBasedProtectedRoute>
            },
            {
                path: 'admins/gigs/:gigId',
                element: <RoleBasedProtectedRoute allowedRole={['admin', 'super-admin']} backTo="/admins/signin"><AdminGigDetail /></RoleBasedProtectedRoute>
            },
            {
                path: 'admins/edit-gig/:gigId',
                element: <RoleBasedProtectedRoute allowedRole={['admin', 'super-admin']} backTo="/admins/signin"><EditGig /></RoleBasedProtectedRoute>
            },
            {
                path: 'admins/dashboard',
                element: <RoleBasedProtectedRoute allowedRole={['admin', 'super-admin']} backTo="/admins/signin"><AdminDashboard /></RoleBasedProtectedRoute>
            },
            {
                path: 'admins/projects',
                element: <RoleBasedProtectedRoute allowedRole={['admin', 'super-admin']} backTo="/admins/signin"><Projects /></RoleBasedProtectedRoute>
            },
            {
                path: 'admins/project-requests',
                element: <RoleBasedProtectedRoute allowedRole={['admin', 'super-admin']} backTo="/admins/signin"><ProjectRequests /></RoleBasedProtectedRoute>
            },
            {
                path: 'admins/new-category',
                element: <RoleBasedProtectedRoute allowedRole={['admin', 'super-admin']} backTo="/admins/signin"><NewCategory /></RoleBasedProtectedRoute>
            },
            {
                path: 'admins/add-new-hellocian',
                element: <RoleBasedProtectedRoute allowedRole={['admin', 'super-admin']} backTo="/admins/signin"><AddNewHellocian /></RoleBasedProtectedRoute>
            },
            {
                path: 'hellocians/overview',
                element: <RoleBasedProtectedRoute allowedRole={['hellocian']} backTo="/"><HellocianProjects /></RoleBasedProtectedRoute>
            },
            {
                path: 'hellocians/projects',
                element: <RoleBasedProtectedRoute allowedRole={['hellocian']} backTo="/"><HellocianOverview /></RoleBasedProtectedRoute>
            },
            {
                path: 'hellocians/settings',
                element: <RoleBasedProtectedRoute allowedRole={['hellocian']} backTo="/"><HellocianSettings /></RoleBasedProtectedRoute>
            },
            {
                path: 'hellocians/messages/:chatId?',
                element: <RoleBasedProtectedRoute allowedRole={['hellocian']} backTo="/"><Messaging /></RoleBasedProtectedRoute>
            }
        ]
    }
]);
